import { useEffect, useState } from 'react';

/**
 * Returns a debounced value that is updated after the delay lapses.
 */
const useDebouncedValue = (value, delay = 800) => {
  const [debouncedValue, setDebouncedValue] = useState();

  useEffect(() => {
    let handler;

    if (!value) {
      setDebouncedValue('');
      // clear out the pending timer since the most current value is empty.
      clearTimeout(handler);
    } else {
      handler = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);
    }

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};

export default useDebouncedValue;
